import { IApplicationState } from '../../types/redux';

export function selectIsLeaveContactsModalOpened(state: IApplicationState) {
  return state.leaveContacts.isOpened;
}
